export const enum PATHS {
  account = '/account',
  app = '/app',
  assignmentDetails = ':assignmentId',
  assignments = 'assignments',
  contactZenjob = 'contact-zenjob',
  deleteProfile = 'delete-profile',
  error = '/error',
  geolocation = 'geolocation',
  languageSettings = 'language',
  login = '/login',
  notificationSettings = 'notification-settings',
  privacySettings = 'privacy',
  reasonDetails = 'reason/:reasonId',
  root = '/',
  shiftDetails = 'shift/:shiftId',
  weekDetails = ':weekId',
  weeks = '/weeks'
}

export const PAGE_EVENT_NAME_BY_PATH = {
  [PATHS.account]: 'account_page_opened',
  [PATHS.login]: 'login_page_opened',
  [PATHS.error]: 'error_page_opened',
  [PATHS.app]: 'app_landing_page_opened',
  [PATHS.assignments]: 'assignment_management_page_opened',
  [PATHS.assignmentDetails]: 'assignment_details_page_opened',
  [PATHS.contactZenjob]: 'contact_zenjob_page_opened',
  [PATHS.deleteProfile]: 'delete_profile_page_opened',
  [PATHS.languageSettings]: 'language_settings_page_opened',
  [PATHS.root]: '',
  [PATHS.shiftDetails]: 'shift_details_page_opened',
  [PATHS.reasonDetails]: 'reason-details_page_opened',
  [PATHS.weekDetails]: 'week_details_page_opened',
  [PATHS.weeks]: 'weeks_overview_page_opened'
};
